import React, { createContext, useContext, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authState, setAuthState] = useState(null);
  const [user, loading, error] = useAuthState(auth);

  const setUserContext = (userData) => {
    setAuthState(userData);
  };

  const value = {
    uid: user?.uid || null,
    id: null,
    user,
    loading,
    error,
    setUserContext,
    ...authState, // Include other user fields from the backend
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
